import { Dialog } from '@mui/material';
import NomineeExporter from 'lib/common/NomineeExporter';
import HeaderWithActions, {
  CustomButtonProps,
} from 'lib/designSystem/HeaderWithActions';
import EnhancedTable from 'lib/designSystem/Table';
import React, { useState } from 'react';

import GeneratePayoutStep from '../../../Create/GeneratePayouts';

const headers: { key: string; label: string; type?: any }[] = [
  { key: 'businessOriginName', label: 'Cuenta Origen' },
  { key: 'bankAccountOriginName', label: 'Banco Origen' },
  { key: 'businessDestinationName', label: 'Cuenta Destino' },
  { key: 'bankAccountDestinationName', label: 'Banco Destino' },
  { key: 'executedAt', label: 'Giro', type: 'date' },
  { key: 'amount', label: 'Monto', type: 'money' },
];

const PayOutDetailPayouts = (props: any) => {
  const { payments, sourceId, setSuccess, setFailure, reset } = props;
  const [selectedPayments, setSelectedPayments] = useState([]);
  const [generateNomineeOpen, setGenerateNomineeOpen] = useState(false);
  const [nomineeExporterOpen, setNomineeExporterOpen] = useState(false);

  const cantSelectRow = (row: any) => {
    return row.executedAt;
  };

  const canSelectAll = () => {
    return !payments.every((payment: any) => payment.executedAt);
  };

  const buttons: CustomButtonProps[] = [
    {
      action: () => setGenerateNomineeOpen(true),
      name: 'Agregar',
      color: 'primary',
      disabled: payments.length > 0,
    },
    {
      action: () => setNomineeExporterOpen(true),
      name: 'Exportar',
      color: 'secondary',
    },
  ];

  function handleSuccesStep(stepFunction: () => void) {
    const auxFunction = () => {
      stepFunction();
      setSuccess('Pago configurado con éxito');
      reset();
    };
    return auxFunction;
  }

  return (
    <div>
      <HeaderWithActions
        title="Acá puedes ver los pagos de la nómina."
        variant="body1"
        buttons={buttons}
      />
      <Dialog
        open={generateNomineeOpen}
        maxWidth="lg"
        onClose={() => setGenerateNomineeOpen(false)}
      >
        <GeneratePayoutStep
          stepBack={() => setGenerateNomineeOpen(false)}
          nextStep={handleSuccesStep(() => setGenerateNomineeOpen(false))}
          selectedRequest={sourceId}
          setFailureOpen={setFailure}
        />
      </Dialog>

      <EnhancedTable
        dataHeaders={headers}
        data={payments}
        selected={selectedPayments}
        setSelected={setSelectedPayments}
        canSelectAll={canSelectAll()}
        cantSelectRow={cantSelectRow}
        finalSumRow
      />

      <NomineeExporter
        open={nomineeExporterOpen}
        setOpen={setNomineeExporterOpen}
        payments={payments}
        id={sourceId}
      />
    </div>
  );
};

export default PayOutDetailPayouts;
